<p>
  document-viewer-with-preview works!
</p>
